import { render, staticRenderFns } from "./CustomErrorMessage.vue?vue&type=template&id=163fadb8&scoped=true&"
import script from "./CustomErrorMessage.vue?vue&type=script&lang=js&"
export * from "./CustomErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./CustomErrorMessage.vue?vue&type=style&index=0&id=163fadb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fadb8",
  null
  
)

export default component.exports